
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFormContext } from "react-hook-form";
import { useProducts } from "../hooks/useProducts";

export const ProductSelect = () => {
  const { control } = useFormContext();
  const products = useProducts();

  return (
    <FormField
      control={control}
      name="feature_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Product</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select a product" />
              </SelectTrigger>
            </FormControl>
            <SelectContent 
              position="popper" 
              className="w-full min-w-[200px] bg-popover"
              sideOffset={4}
            >
              {products.map((product) => (
                <SelectItem key={product.id} value={product.id}>
                  {product.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
